<template>
	<div class="table-footer">
		<div class="row">
			<div class="col-md-4">
				<span>Show</span>
				<select
					class="form-control"
					v-model="showPerPage"
					id="resultsPerPage"
					@change="showPerPageChanged"
				>
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
				</select>
				<span>entries</span>
			</div>
			<div class="col-md-4 text-center">
				<!-- <span> Selected Ones</span>
                <button class="btn btn-danger" onclick="deleteCampaignGroup();">
                    <svg viewBox="0 0 8 8" class="icon fill-white">
                            <use
                            xlink:href="images/open-iconic.svg#trash"></use>
                        </svg>
                    Delete
				</button>-->
			</div>
			<div class="col-md-4 text-right">
				<a href="javascript:void(0)" v-if="currentPageNumber!=1" @click="getPreviousPageList()">Previous</a>
				<select
					class="form-control selectpicker"
					style="max-width:70px;padding:2px"
					id="brandFilter"
					v-model="currentPageNumber"
					@change="getNewPageList()"
				>
					<option v-for="index in totalNoOfPages" :key="index" :value="index">{{index}}</option>
				</select>
				<a
					href="javascript:void(0)"
					v-if="(showPerPage == automationList.length) && (currentPageNumber!=totalNoOfPages)"
					@click="getNextPageList()"
				>Next</a>
				<div style="padding-right:0px;padding-top:5px">{{getCount()}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "CampaignGroupGridFooter",
		data() {
			return {
				totalNoOfPages: 1
			};
		},
		watch: {
			automationCount() {
				this.calculateIndexPerPage();
			}
		},
		computed: {
			automationCount: {
				set(val) {
					this.$store.commit("automation/updateAutomationCount",val);
				},
				get() {
					return this.$store.getters["automation/recieveAuomationCount"];
				}
			},
			showPerPage: {
				set(val) {
					this.currentPageNumber = 1
					sessionStorage.setItem("automation:showPerPage", val);
				},
				get() {
					if (sessionStorage.getItem("automation:showPerPage")) {
						return sessionStorage.getItem("automation:showPerPage");
					}
					return this.$store.state.showPerPage;
				}
			},
			currentPageNumber: {
				set(val) {
					this.$store.state.currentPageNumber = val;
				},
				get() {
					return this.$store.state.currentPageNumber;
				}
			},
			automationList() {
				return this.$store.state.automation.automationList;
			},
			subTargetValue:{
				set(val){
					 this.$store.state.automation.subTargetValue = val
				},
				get(){
					return this.$store.state.automation.subTargetValue
				}
			},
			subTarget:{
				set(val){
					this.$store.state.automation.subTarget = val
					this.subTargetValue = null
				},
				get(){
					return this.$store.state.automation.subTarget
				}
			},
		},
		mounted() {
			this.calculateIndexPerPage();
		},
		methods: {
			getAutomationCalls(){
				if(this.subTargetValue && this.subTarget){
					this.$store.dispatch("automation/getAutomationsFiltered");
				}
				else{
					this.$store.dispatch("automation/getAutomations")
				}
			},
			calculateIndexPerPage() {
				this.totalNoOfPages = Math.ceil(
					this.automationCount / this.showPerPage
				);
			},
			getPreviousPageList() {
				if (this.currentPageNumber <= 1) {
					return;
				} else {
					this.currentPageNumber -= 1;
					this.getAutomationCalls()
					//this.$store.dispatch("automation/getAutomations");
				}
			},
			getNextPageList() {
				this.currentPageNumber += 1;
				this.getAutomationCalls()
				//this.$store.dispatch("automation/getAutomations");
			},
			getNewPageList() {
				this.getAutomationCalls()
				// this.$store.dispatch("automation/getAutomations");
			},
			getCount() {
				let pageCount = this.showPerPage * (this.currentPageNumber - 1);
				let extendedcount =
					parseInt(pageCount) + parseInt(this.automationList.length);
				//return	pageCount+1 + ' to ' + extendedcount;
				return (
					"Showing " +
					(pageCount + 1) +
					" to " +
					extendedcount +
					" results of " +
					this.automationCount
				);
			},
			showPerPageChanged() {
				this.getAutomationCalls()
				// this.$store.dispatch("automation/getAutomations");
			}
		}
	};
</script>

<style lang="scss">
</style>
